export enum PrivilegeLevel {
  NONE = 'none',
  SOME = 'some',
  ALL = 'all',
}
